import { FIELD_NAME } from '../constants/form-constants';
import { formService } from '../form-service';
import { NdpsDealer } from '../types/dealer-types';

class DealerEntityClass {
	private static instance: DealerEntityClass;

	private constructor() {}

	static getInstance(): DealerEntityClass {
		if (!DealerEntityClass.instance) {
			DealerEntityClass.instance = new DealerEntityClass();
		}
		return DealerEntityClass.instance;
	}

	get dealer(): NdpsDealer | undefined {
		return formService.getFieldValue(FIELD_NAME.DEALER) as NdpsDealer;
	}

	get id(): string | undefined {
		return this.dealer?.Id;
	}

	get code(): string | undefined {
		return this.dealer?.VGED_DealerCode__c;
	}

	get kvps(): string | undefined {
		return this.dealer?.KVPSCode__c;
	}

	get name(): string | undefined {
		return this.dealer?.VGED_CommercialName__c;
	}

	get address(): string | undefined {
		return this.dealer?.ShippingStreet;
	}

	get postalCode(): string | undefined {
		return this.dealer?.ShippingPostalCode;
	}

	get provinceCode(): string | undefined {
		return this.dealer?.ShippingStateCode
			? this.dealer.ShippingStateCode.toString().padStart(2, '0')
			: this.dealer?.ShippingPostalCode
				? this.dealer.ShippingPostalCode.toString().slice(0, 2)
				: undefined;
	}
}

export const dealerEntity = DealerEntityClass.getInstance();
